









































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'GestionDataSources',  
})
export default class GestionDataSources extends Vue {
  private loading = false
  private showError = false
  
  private toolbarHeight = 50

  private get tableauHeight() {    
    return this.$store.myGetters.contentHeight - this.toolbarHeight - 25
  }

  onResize(){
    //@ts-ignore
    this.toolbarHeight = this.$refs.toolbar.$el.clientHeight
  }  

  private get dataSourcesList() {
    return this.$store.myGetters.dataSourcesList
  }
  
  private get search(){
    return this.$store.myGetters.searchDataSource
  }
  private set search(value){
    this.$store.myActions.UI_SET_SEARCH_DATASOURCE(value)
  }

  private get sortDesc(){
    return this.$store.myGetters.sortDataSourceDesc
  }
  private set sortDesc(value){
    this.$store.myActions.UI_SET_SORT_DATASOURCE_DESC(value)
  }

  private get sortBy(){
    return this.$store.myGetters.sortDataSourceBy
  }
  private set sortBy(value){
    this.$store.myActions.UI_SET_SORT_DATASOURCE_BY(value)
  }

  private headers = [
    { text: 'ID', value: 'id' },
    { text: 'DataSource', value: 'libelle' },
    { text: 'Position', value: 'dsoPos' }/*,
    { text: 'Priorité', value: 'priorite' }*/
  ]

  created() {
    this.loading = true
    this.$store.myActions.ADM_DATASOURCE_ENSURE().finally(() => {
      this.loading = false
    })
  }


  openDetail(item: any) {
    this.$router.push({name:'ModifyDataSources',params:{dsoId:item.id}})
  }

  addDataSource(){
    //@ts-ignore
    this.$router.push({name:'ModifyDataSources',params:{dsoId:0}})
  } 
}
